import { stitch } from 'keo';
import PropTypes from 'prop-types';
import r from 'render-dom';

import { componentOrNull } from 'utils/helpers';

const propTypes = {
    navTitle: PropTypes.node,
    onNavClick: PropTypes.func,
};

const render = ({ props }) => {
    const {
        navTitle = '',
        onNavClick,
    } = props;
    const style = {
        nav: {
            backgroundColor: '#eaeaea',
            padding: '10px 30px',
        },
        navTitle: {
            color: '#0085d5',
            cursor: onNavClick ? 'pointer' : 'default',
        },
    };

    return componentOrNull(
        navTitle,
        r.div({ style: style.nav }, [
            r.span({ onClick: onNavClick, style: style.navTitle }, [
                navTitle
            ]),
        ])
    );
};

export default stitch({ propTypes, render });



// WEBPACK FOOTER //
// ./src/components/shared/StickyHeader/NavSection/NavSection.js